import { useEffect } from "react";

import { bucketWithTypeByIdQueryOptions } from "@/api/buckets/bucketWithTypeByIdQueryOptions";
import { useQueryErrorResetBoundary } from "@tanstack/react-query";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import z, { ZodError } from "zod";

import { Button } from "@workspace/ui/components/button";

import { BucketDashboard } from "./-components/BucketDashboard";

const bucketIdSchema = z.coerce.number().int().positive();

export const Route = createFileRoute("/_standard/buckets/$bucketId/")({
  params: {
    parse: (params) => ({
      bucketId: bucketIdSchema.parse(params.bucketId),
    }),
  },
  loader: ({ context: { queryClient }, params: { bucketId } }) => {
    return queryClient.ensureQueryData(bucketWithTypeByIdQueryOptions(bucketId));
  },
  component: RouteComponent,
  errorComponent: ErrorComponent,
});

function RouteComponent() {
  return <BucketDashboard />;
}

function ErrorComponent({ error }: { error: Error }) {
  const { reset: tanStackReset } = useQueryErrorResetBoundary();
  const router = useRouter();

  useEffect(() => {
    tanStackReset();
  }, [tanStackReset]);

  if (error instanceof ZodError) {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-4 p-10">
        {/* Makes no sense to offer retry button if bucket id is invalid */}
        <p>Ungültige Bucket-ID</p>
      </div>
    );
  }

  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 p-10">
      <p>Ein Fehler ist aufgetreten</p>
      <Button
        onClick={() => {
          void router.invalidate();
        }}
      >
        Erneut versuchen
      </Button>
    </div>
  );
}
